<template>
  <div class="col-md-10 offset-md-2">
    <h3>Lista de limpieza de backups</h3>
    <b-table striped hover :items="backups_clean" :fields="fields">
      <template v-slot:cell(action)="">
        <div class="row d-flex justify-content-center">
          <b-button size="sm" variant="primary">Editar</b-button>
          <b-button size="sm" variant="danger">Eliminar</b-button>
        </div>
        
      </template>
    </b-table>
  </div>
</template>

<script>
import {TokenService} from "./../storage/service"
export default {
  name: 'BackupsCleanUp',
  props: {
    msg: String
  },
  data: function () {
    return {
      servers: [],
      backups_clean: [],
      fields: [
        {key: 'id', label: 'ID'},
        {key: 'name', label:'Name'},
        {key: 'server.name', label:'Servidor origen'},
        {key: 'server_id_dest.name', label:'Servidor Destino'},
        {key: 'backups_path', label:'Carpeta a limpiar'},
        {key: 'dest_server_backups_path', label:'Carpeta destino a comparar'},
        {key: 'days_to_keep', label:'Dias a mantener'},
        {key: 'action', label:''}
      ]
    };
  },
  mounted() {
    this.login();
    this.fetchBackupsCleanUp();
  },
  methods: {
    login(){
      let token = TokenService.getToken()
      this.$http.post(this.backendURL + 'api/v1.0/checkSession/', {headers: {'Authorization': 'Token ' + token}})
      .then(() => {
        console.log("Token Correcto")
      })
      .catch(err => {
        // catch error});
        if(err.request.statusText == 'Unauthorized'){
          alert("Su sesion ha expirado...")
          this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
        }
        else {
          console.log(err.data)
        }
      })
    },
    fetchBackupsCleanUp() {
      let url = this.backendURL + 'api/v1.0/BackupsClean/';
      this.$http.get(url)
      .then( result => {
        this.backups_clean = result.data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 25px 0 0;
}
button {
  margin: 0 5px;
}

.vue-form-generator .field-switch input:checked~.label{
  background: #2f9401;
}

</style>
